import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'calloutsSatisfaction',
    label: 'Satisfaction Callouts',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
